/**
 * IB Centenario - main script entry point.
 *
 * @module main
 */

import $ from 'jquery';
import whatInput from 'what-input';
import * as bootstrap from 'bootstrap';

import { Loading } from './esm/loading.esm.js';
import { MyHD } from './esm/header.esm.js';
import { Video } from './esm/video.esm.js';
import { Countdown } from './esm/countdown.esm.js';
import { ScrollCta } from './esm/scrollcta.esm.js';
import { GalleryScroll } from './esm/galleryscroll.esm.js';
import { SplitLines } from './esm/splitlines.esm.js';
import { Marco } from './esm/marco.esm.js';
import { News } from './esm/news.esm.js';
import { Plane } from './esm/plane.esm.js';
import { PlaneScroll } from './esm/planescroll.esm.js';
import { initResizeWatcher } from './esm/resize.esm.js';

document.addEventListener( 'DOMContentLoaded' , ( event ) => {
  Loading.initAll( );
  MyHD.initAll( );
  Video.initAll( );
  Countdown.initAll( );
  ScrollCta.initAll( );
  GalleryScroll.initAll( );
  SplitLines.initAll( );
  Marco.initAll( );
  News.initAll( );
  Plane.initAll( );
  PlaneScroll.initAll( );
  initResizeWatcher( );

  window.addEventListener( 'breakpointChange' , ( event ) => {
    console.log( '===> breakpointChange => ' , event );
  });
  $( '.collapse' ).on( 'shown.bs.collapse' , ( event ) => {
    console.log( '===> shown.bs.collapse => ' , event );
  });
  $( '.collapse' ).on( 'hidden.bs.collapse' , ( event ) => {
    console.log( '===> hidden.bs.collapse => ' , event );
  });
  window.addEventListener( 'onResizeInit' , ( event ) => {
    console.log( '===> onResizeInit => ' , event );
  });
  window.addEventListener( 'onResizeEnd' , ( event ) => {
    console.log( '===> onResizeEnd => ' , event );
  });
});